import { RouteObject } from 'react-router'

import { ROUTES } from '@/common/constants/routes'
import { AuthenticatedLayout } from '@/common/layouts/AuthenticatedLayout'
import { SsoLayout } from '@/common/layouts/SsoLayout'
import Access from '../sso/pages/Access'
import Accounts from '../sso/pages/Accounts'
import Applications from '../sso/pages/Applications'

export const SsoRoutes: RouteObject[] = [
  {
    element: <AuthenticatedLayout />,
    children: [
      {
        element: <SsoLayout />,
        children: [
          { path: ROUTES.SSO.ACCESS, element: <Access /> },
          { path: ROUTES.SSO.APPLICATIONS, element: <Applications /> },
          { path: ROUTES.SSO.ACCOUNTS, element: <Accounts /> },
        ],
      },
    ],
  },
]
